import { IBetBuilderBetState, defaultBetBuilderBetState } from '../bet-builder/models';
import { IComboBetState, defaultComboBetState } from '../combo-bet/state';
import { IEditMyBetState, defaultEditMyBetState } from '../edit-bet/state';
import { ISingleBetState, defaultSingleBetState } from '../single-bet/state';
import { ISystemBetSavedState, ISystemBetState, defaultSystemBetState } from '../system-bet/state';
import { ITeaserBetSavedState, ITeaserBetState, defaultTeaserBetState } from '../teaser-bet/state';
import { IBaseTypeState, defaultBaseTypeState } from './base/state';

export interface IBetslipTypeState {
    base: IBaseTypeState;
    singleBet: ISingleBetState;
    comboBet: IComboBetState;
    systemBet: ISystemBetState;
    teaserBet: ITeaserBetState;
    editBet: IEditMyBetState;
    betBuilder: IBetBuilderBetState;
}

export interface IBetslipTypeSavedState extends Omit<IBetslipTypeState, 'systemBet' | 'teaserBet' | 'editBet'> {
    systemBet: ISystemBetSavedState;
    teaserBet: ITeaserBetSavedState;
}

export const defaultBetslipTypeState: IBetslipTypeState = {
    base: defaultBaseTypeState,
    singleBet: defaultSingleBetState,
    comboBet: defaultComboBetState,
    systemBet: defaultSystemBetState,
    teaserBet: defaultTeaserBetState,
    editBet: defaultEditMyBetState,
    betBuilder: defaultBetBuilderBetState,
};
